import { getSingularPluralTextFormatter } from "../formatters";
import { ServicePriceUnit } from "@farmact/model/src/model/services/Service";

export function getServicePriceUnitName(unit: ServicePriceUnit, count = 0): string {
    switch (unit) {
        case ServicePriceUnit.FLAT:
            return "Pauschale";
        case ServicePriceUnit.HECTARE:
            return "Hektar";
        case ServicePriceUnit.HOUR:
            return getSingularPluralTextFormatter("Stunde", "Stunden")(count);
        case ServicePriceUnit.SQUAREMETER:
            return "Quadratmeter";
        case ServicePriceUnit.METER:
            return "Meter";
        case ServicePriceUnit.KILOMETER:
            return "Kilometer";
        case ServicePriceUnit.TONS:
            return "Tonnen";
        case ServicePriceUnit.CUBIC_METERS:
            return "Kubikmeter";
        case ServicePriceUnit.LITER:
            return "Liter";
    }
}

export function getServicePriceShortUnitName(unit: ServicePriceUnit | string): string {
    switch (unit) {
        case ServicePriceUnit.FLAT:
            return "Pauschale";
        case ServicePriceUnit.HECTARE:
            return "ha";
        case ServicePriceUnit.HOUR:
            return "h";
        case ServicePriceUnit.SQUAREMETER:
            return "qm";
        case ServicePriceUnit.METER:
            return "m";
        case ServicePriceUnit.KILOMETER:
            return "km";
        case ServicePriceUnit.TONS:
            return "t";
        case ServicePriceUnit.CUBIC_METERS:
            return "m³";
        case ServicePriceUnit.LITER:
            return "l";
        default:
            return unit;
    }
}
